(function ($) {
  "use strict";

  /*** Home page Scripts***/

  /* Init TinySlider2 */
  if (typeof tns === 'function') {
    const marketCap = document.getElementById('market_cap');

    if (marketCap) {
      tns({
        container: marketCap,
        items: 3,
        slideBy: '1',
        speed: 400,
        nav: false,
        mouseDrag: true,
        viewportMax: 1504,
        responsive: {
          768: {
            items: 4
          },
          1024: {
            items: 6
          },
          1400: {
            items: 6
          },
        },
        onInit() {
          document.getElementById('coinmarket_cap').style.opacity = 1;
        }
      });
    }

    $(document).on('click', '#cap_control', function(e) {
      e.preventDefault();
      const $nextControl = $('.coinMarketCap').find('[data-controls="next"]');

      if ($nextControl.length) {
        $nextControl.click();
      }
    });
  }

})(jQuery);
